import ListColumnModel from '@/modules/base/model/list-column-model'
import { todoStateMap, todoTypeMap } from '@/modules/todo/components/_helpers/getState'
import store from '@/redux/store'

const getTodoType = (value) => {
  return todoTypeMap.has(value) ? todoTypeMap.get(value) : value
}

export default class TodoListColumnModel extends ListColumnModel {
  constructor(data) {
    super(data)
    const { subscriptions } = store.getState().tenant.info
    const isTaxConsultant = subscriptions?.some(s => s.isTaxConsultant)

    this.displayed = data.displayed

    switch (this.name) {
      case 'status': {
        this.cellRenderer = 'stateCellRenderer'
        this.filter = false
        this.setFilterParam({
          valueFormatter: (param) => {
            const { type } = param.data
            return todoStateMap(type).get(param.value)
          },
        })
        this.getQuickFilterText = (params) => {
          return params.node?.data?.stateLabel || params.value
        }
        break
      }
      case 'unseen': {
        this.cellRenderer = 'unseenCellRenderer'
        this.filter = false
        this.field = 'isSeen'
        this.setFilterParam({
          valueFormatter: (param) => param.data.isSeen === false,
        })
        this.getQuickFilterText = () => 'isSeen'
        break
      }
      case 'title': {
        this.setTextType()
        break
      }
      case 'dueFromDate':
      case 'dueToDate':
      case 'createdAt':{
        this.setDateType()
        break
      }
      case 'updatedAt': {
        this.setDateTimeType()
        break
      }
      case 'type': {
        this.valueFormatter = ({ value }) => getTodoType(value)
        break
      }
      case 'clientNumber':
      case 'clientName':
        if (!isTaxConsultant) {
          this.hide = !this.displayed
        }
        break
      default:
        break
    }
  }
}
